// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconPhone = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='phone'
			xmlns='http://www.w3.org/2000/svg'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path d='M7.52 10.996a12.55 12.55 0 0 0 5.492 5.487l1.834-1.837a.84.84 0 0 1 .846-.204 9.5 9.5 0 0 0 2.975.475.83.83 0 0 1 .833.833v2.917a.83.83 0 0 1-.833.833C10.842 19.5 4.5 13.158 4.5 5.333c0-.462.375-.833.833-.833H8.25a.83.83 0 0 1 .833.833c0 1.038.167 2.042.475 2.975a.84.84 0 0 1-.204.846z' />
		</svg>
	)
}
